<template>
  <button
    class="flex h-20 w-full cursor-pointer flex-row items-center space-x-3 p-3"
    type="button"
  >
    <div
      class="relative flex size-12 items-center justify-center rounded bg-primary text-white"
      :style="{ backgroundColor: product.color }"
    >
      {{ productShortString }}
    </div>
    <div class="flex flex-1 items-center justify-start">
      <div class="line-clamp-2 text-left text-sm">
        {{ product.name }}
      </div>
    </div>
    <div class="flex items-center justify-end">
      <p
        class="line-clamp-1 text-right text-sm font-semibold"
      >
        {{ priceString }}
      </p>
    </div>
  </button>
</template>

<script setup lang="ts">
import type { Product } from "@/services/sharedTypes/products"

const props = defineProps<{
  product: Product
}>()

const {
  formatToMerchantCurrencyString,
  merchantCurrencySymbol,
} = useCurrency()

const emit = defineEmits(["click-dots"])

const priceString = computed(() =>
  props.product.hasVariablePrice
    ? `${merchantCurrencySymbol.value} variable`
    : formatToMerchantCurrencyString(props.product.price)
)

const productShortString = computed(() => {
  const strippedName = props.product.name
    .toLowerCase()
    .replace(" ", "")
  return `${strippedName
    .charAt(0)
    .toUpperCase()}${strippedName.charAt(1)}`
})
</script>
